// @ts-nocheck
/**
 * fileOperations.ts
 * ファイル操作（DXF/SIMA/PNG/JPG/GeoTIFF/Shapefile）関連メソッド
 * App.vue から切り出し
 */

import axios from 'axios'
import DxfParser from 'dxf-parser'
import store from '@/store'
import { db } from '@/firebase'
import { consumeToken } from '@/js/tokenService'
import {
  zipDownloadDxfText,
  pngDownload,
  dxfLoadForUser,
  dxfToGeoJSON,
  geojsonAddLayer,
  pngLoad,
  jpgLoad,
  geoTiffLoad,
  geoTiffLoad2,
  tileGenerateForUser,
  tileGenerateForUserPdf,
  csvGenerateForUserPng,
  pmtilesGenerateForUser2,
  simaLoadForUser,
  ddSimaUpload,
  downloadSimaText,
  zipDownloadSimaText,
  extractSimaById,
  handleFileUpload,
} from '@/js/downLoad'

type VM = any

export function save(vm: VM) {
  vm.saveSelectedPointFeature()
  // Firestore に保存
  const groupId = vm.$store.state.currentGroupName
  const geojson = vm.$store.state.groupGeojson
  db.collection('groups').doc(groupId).set({
    layers: {
      points: geojson
    },
    lastModifiedBy: vm.$store.state.userId,
    lastModifiedAt: Date.now()
  }, { merge: true })

  close(vm)
}

export function close(vm: VM) {
  vm.setPointInfoDrawer(false)
}

export function setDrawerVisible(vm: VM, val) {
  vm.setPointInfoDrawer(val)
}

export function setRightVisible(vm: VM, val) {
  vm.setRightDrawer(val)
}

export function savePointDescription(vm: VM, description) {
  const feature = { ...vm.selectedPointFeature }
  feature.properties.description = description
}

export function openFeatureDrawer(vm: VM, feature) {
  vm.selectedFeature = feature
  vm.drawerVisible = true
}

export function handleDescriptionSave(vm: VM, newDescription) {
  vm.selectedFeature.properties.description = newDescription
}

export function simaClose(vm: VM) {
  vm.s_snackbar = false
}

export function myRoom(vm: VM) {
  vm.s_dialogForLink = !vm.s_dialogForLink
  if (vm.s_isAndroid) {
    let startY
    let isTouching = false
    let currentTarget = null
    let initialScrollTop = 0
    document.addEventListener('touchstart', (e) => {
      const target = e.target.closest('.scrollable-content, .v-overlay-container .v-select__content')
      if (target) {
        startY = e.touches[0].clientY
        initialScrollTop = target.scrollTop
        isTouching = true
        currentTarget = target
        target.style.overflowY = 'auto'
        target.style.touchAction = 'manipulation'
        e.stopPropagation()
      }
    }, { passive: true, capture: true })

    document.addEventListener('touchmove', (e) => {
      if (!isTouching || !currentTarget) return
      const moveY = e.touches[0].clientY
      const deltaY = startY - moveY
      currentTarget.scrollTop += deltaY
      startY = moveY
      e.preventDefault()
      e.stopPropagation()
    }, { passive: false, capture: true })

    document.addEventListener('touchend', () => {
      if (currentTarget) {
        currentTarget.style.overflowY = ''
      }
      currentTarget = null
      isTouching = false
      initialScrollTop = 0
    }, { passive: true })
  }
}

export function updateSnackbar(vm: VM) {
  vm.loadingSnackbar = vm.s_loading || vm.s_loading2 || vm.s_loading3
}

export function onResize(vm: VM) {
  vm.windowWidth = window.innerWidth
}

export function simaDelete(vm: VM) {
  const geoJSON = {
    type: 'FeatureCollection',
    features: []
  }
  const map01 = vm.$store.state.map01
  if (map01.getSource('sima-data')) {
    map01.getSource('sima-data').setData(geoJSON)
  } else {
    alert('レイヤーから削除してください。')
  }
  vm.$store.state.simaText = ''
}

export function fileClose(vm: VM) {
  vm.s_snackbar = false
}

export function dxfDl(vm: VM) {
  const map01 = vm.$store.state.map01
  let ids = []
  map01.getStyle().layers.forEach(layer => {
    if (layer.id.includes('oh-dxf-')) {
      const id = layer.id.split('-')[2]
      if (id && !ids.includes(id)) {
        ids.push(id)
      }
    }
  })
  ids = [...new Set(ids)]

  // 各IDに対してDXFデータをフェッチ
  const fetchPromises = ids.map(id =>
    axios.get('/oh3/php/userDxf.php', {
      params: { action: 'selectById', id: id }
    })
  )

  Promise.all(fetchPromises)
    .then(responses => {
      const dxfTexts = responses
        .filter(response => response.data.result)
        .map(response => ({
          dxfText: response.data.result.dxftext,
          name: response.data.result.name
        }))
      zipDownloadDxfText(dxfTexts)
    })
    .catch(error => {
      console.error('DXFダウンロードエラー:', error)
      vm.$store.dispatch('messageDialog/open', {
        id: 'global',
        title: 'エラー',
        contentHtml: '<p>DXFダウンロードに失敗しました</p>',
        options: { icon: 'mdi-alert-circle', iconColor: 'error' }
      })
    })
}

export function dxfPartDl(vm: VM) {
  const map01 = vm.$store.state.map01
  let ids = []
  const features = map01.queryRenderedFeatures()
  const dxfLayers = new Set()
  features.forEach(f => {
    if (f.layer.id.includes('oh-dxf-')) {
      const id = f.layer.id.split('-')[2]
      if (id) {
        dxfLayers.add(id)
      }
    }
  })
  ids = Array.from(dxfLayers)

  const fetchPromises = ids.map(id =>
    axios.get('/oh3/php/userDxf.php', {
      params: { action: 'selectById', id: id }
    })
  )

  Promise.all(fetchPromises)
    .then(responses => {
      const dxfData = responses
        .filter(response => response.data.result)
        .map(response => ({
          dxfText: response.data.result.dxftext,
          name: response.data.result.name,
          id: response.data.result.id
        }))

      if (dxfData.length === 0) {
        vm.$store.dispatch('messageDialog/open', {
          id: 'global',
          title: 'エラー',
          contentHtml: '<p>DXFレイヤーが見つかりません</p>',
          options: { icon: 'mdi-alert-circle', iconColor: 'error' }
        })
        return
      }

      const highlightedDxfs = Array.from(vm.$store.state.highlightedDxfs)
      if (highlightedDxfs.length === 0) {
        vm.$store.dispatch('messageDialog/open', {
          id: 'global',
          title: 'エラー',
          contentHtml: '<p>1件も選択されていません。</p>',
          options: { icon: 'mdi-alert-circle', iconColor: 'error' }
        })
        return
      }

      const fileName = dxfData[0].name
      const blob = new Blob([dxfData[0].dxfText], { type: 'application/octet-stream' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = fileName + '部分DL.dxf'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(link.href)
    })
    .catch(error => {
      console.error('DXF部分ダウンロードエラー:', error)
      vm.$store.dispatch('messageDialog/open', {
        id: 'global',
        title: 'エラー',
        contentHtml: '<p>DXF部分ダウンロードに失敗しました</p>',
        options: { icon: 'mdi-alert-circle', iconColor: 'error' }
      })
    })
}

export function dxfDelete(vm: VM) {
  vm.$store.dispatch('messageDialog/open', {
    id: 'global',
    title: '情報',
    contentHtml: '<p>レイヤーから削除してください。</p>',
    options: { icon: 'mdi-information', iconColor: 'info' }
  })
}

export function pngDownloadFn(vm: VM) {
  pngDownload()
  vm.$store.state.dialogForPngApp = false
}

export function dxfLoad(vm: VM) {
  if (vm.$store.state.userId) {
    const map1 = vm.$store.state.map01
    dxfLoadForUser(map1, true, vm.$store.state.dxfText.text)
  } else {
    const map01 = vm.$store.state.map01
    const map02 = vm.$store.state.map02
    const parser = new DxfParser()
    vm.$store.state.dxfText.zahyokei = vm.$store.state.zahyokei
    const dxf = parser.parseSync(vm.$store.state.dxfText.text)
    const geojson = dxfToGeoJSON(dxf)
    geojsonAddLayer(map01, geojson, true, 'dxf')
    geojsonAddLayer(map02, geojson, true, 'dxf')
  }
  vm.dialogForDxfApp = false
}

export function shpLoad(vm: VM) {
  if (!vm.s_pmtilesName || !vm.s_pmtilesPropertieName) {
    alert("入力されていません。")
    return
  }
  if (vm.s_selectedPublic === -1) {
    if (!confirm("緑色(オープンデータ)で公開しようとしています。全ユーザーが閲覧可能になります。良いですか？")) {
      return
    }
  }
  if (vm.s_selectedPublic === 1) {
    if (!confirm("青色(公開)で公開しようとしています。全ユーザーが閲覧可能になります。良いですか？")) {
      return
    }
  }
  pmtilesGenerateForUser2(vm.s_chibanzuGeojson, '', store.state.pmtilesPropertieName, vm.s_chibanzuPrefCode, String(vm.s_chibanzuCityCode).padStart(5, '0'), vm.s_selectedPublic, vm.s_selectedKaiji2, vm.s_geojsonFile)
  vm.s_showChibanzuDialog = false
}

export function imagePngLoad(vm: VM) {
  csvGenerateForUserPng(vm.s_zahyokei)
  vm.dialogForImagePng = false
}

export async function pdfLoad(vm: VM) {
  if (vm.$store.state.userId) {
    // 画像アップロード: 10pt
    const tokenResult = await consumeToken('import_image')
    if (!tokenResult.success && tokenResult.error !== 'NETWORK_ERROR_IGNORED') return
    tileGenerateForUserPdf()
    vm.dialogForPdfApp = false
  } else {
    alert('ログイン専用です。')
  }
}

export async function pngLoad0(vm: VM) {
  const map01 = vm.$store.state.map01
  const map02 = vm.$store.state.map02
  if (vm.$store.state.userId) {
    // 画像アップロード: 10pt
    const tokenResult = await consumeToken('import_image')
    if (!tokenResult.success && tokenResult.error !== 'NETWORK_ERROR_IGNORED') return
    tileGenerateForUser('png', 'pgw')
  } else {
    pngLoad(map01, 'map01', true)
    pngLoad(map02, 'map02', false)
  }
  vm.s_dialogForPng2App = false
}

export async function jpgLoad0(vm: VM) {
  const map01 = vm.$store.state.map01
  const map02 = vm.$store.state.map02
  if (vm.$store.state.userId) {
    // 画像アップロード: 10pt
    const tokenResult = await consumeToken('import_image')
    if (!tokenResult.success && tokenResult.error !== 'NETWORK_ERROR_IGNORED') return
    vm.$store.state.loadingMessage = 'アップロード開始'
    tileGenerateForUser('jpg,jpeg', 'jgw')
  } else {
    jpgLoad(map01, 'map01', true)
    jpgLoad(map02, 'map02', false)
  }
  vm.s_dialogForJpgApp = false
}

export async function geoTiffLoad0(vm: VM) {
  const map01 = vm.$store.state.map01
  const map02 = vm.$store.state.map02
  if (vm.$store.state.userId) {
    // 画像アップロード: 10pt
    const tokenResult = await consumeToken('import_image')
    if (!tokenResult.success && tokenResult.error !== 'NETWORK_ERROR_IGNORED') return
    tileGenerateForUser('tif,tiff', 'tfw')
  } else {
    geoTiffLoad(map01, 'map01', true)
    geoTiffLoad(map02, 'map02', false)
  }
  vm.s_dialogForGeotiffApp = false
}

export async function geoTifLoad1file(vm: VM) {
  vm.dialogForGeotiffApp1file = false
  vm.s_dialogForGeotiff2App = false
  const map01 = vm.$store.state.map01
  const map02 = vm.$store.state.map02
  if (vm.$store.state.userId) {
    // 画像アップロード: 10pt
    const tokenResult = await consumeToken('import_image')
    if (!tokenResult.success && tokenResult.error !== 'NETWORK_ERROR_IGNORED') return
    tileGenerateForUser('tif,tiff', null)
  } else {
    geoTiffLoad2(map01, 'map01', true)
    geoTiffLoad2(map02, 'map02', false)
  }
}

export function simaOpacityInput(vm: VM) {
  const map1 = vm.$store.state.map01
  const map2 = vm.$store.state.map02
  const maps = [map1, map2]
  if (vm.$store.state.simaText) {
    map1.setPaintProperty('sima-layer', 'fill-opacity', vm.s_simaOpacity)
    map2.setPaintProperty('sima-layer', 'fill-opacity', vm.s_simaOpacity)
    const parsed = JSON.parse(vm.$store.state.simaText)
    parsed['opacity'] = vm.s_simaOpacity
    vm.$store.state.simaText = JSON.stringify(parsed)
  }
  if (vm.$store.state.simaTextForUser) {
    maps.forEach(map => {
      map.getStyle().layers.forEach(layer => {
        if (layer.id.includes('-sima-') && layer.id.includes('polygon')) {
          map1.setPaintProperty(layer.id, 'fill-opacity', vm.s_simaOpacity)
        }
      })
    })
    const parsed = JSON.parse(vm.$store.state.simaTextForUser)
    parsed['opacity'] = vm.s_simaOpacity
    vm.$store.state.simaTextForUser = JSON.stringify(parsed)
  }
}

export function loadSima(vm: VM) {
  if (!vm.s_zahyokei) {
    alert('座標系を選択してください。')
    return
  }
  if (vm.$store.state.isMenu) {
    document.querySelector('#simaFileInput').click()
    vm.$store.state.isMenu = false
    vm.s_dialogForSimaApp = false
  } else {
    if (vm.$store.state.userId) {
      const map1 = vm.$store.state.map01
      simaLoadForUser(map1, true, vm.ddSimaText, vm.s_zahyokei)
    } else {
      ddSimaUpload(vm.ddSimaText)
    }
    vm.s_dialogForSimaApp = false
  }
}

export function simaPartDl(vm: VM) {
  const map01 = vm.$store.state.map01
  let ids = []
  const features = map01.queryRenderedFeatures()
  const simaLayers = new Set()
  features.forEach(f => {
    if (f.layer.id.includes('-sima-')) {
      simaLayers.add(f.layer.id.split('-')[2])
    }
  })
  ids = Array.from(simaLayers)
  const params = new URLSearchParams({ ids: ids })
  ids.forEach(id => params.append('ids[]', id))
  fetch(`/oh3/php/userSimaSelectByIds.php?${params}`, {
    method: "GET"
  })
    .then(response => response.json())
    .then(datanum => {
      const simaTexts = datanum.map(data => {
        return { simaText: data.simatext, name: data.name }
      })
      const highlightedSimas = Array.from(vm.$store.state.highlightedSimas)
      let simaText = simaTexts[0].simaText
      if (highlightedSimas.length === 0) {
        alert('1件も選択されていません。')
        return
      }
      simaText = extractSimaById(simaText, highlightedSimas)
      vm.$store.state.simaTextForUser = simaText
      const fileName = simaTexts[0].name
      downloadSimaText(true, fileName)
    })
}

export function simaDl(vm: VM) {
  if (vm.$store.state.simaText) {
    downloadSimaText(false)
  } else {
    const map01 = vm.$store.state.map01
    let ids = []
    map01.getStyle().layers.forEach(layer => {
      if (layer.id.includes('-sima-')) {
        ids.push(layer.id.split('-')[2])
      }
    })
    ids = [...new Set(ids)]
    const params = new URLSearchParams({ ids: ids })
    ids.forEach(id => params.append('ids[]', id))
    fetch(`/oh3/php/userSimaSelectByIds.php?${params}`, {
      method: "GET"
    })
      .then(response => response.json())
      .then(datanum => {
        const simaTexts = datanum.map(data => {
          return { simaText: data.simatext, name: data.name }
        })
        zipDownloadSimaText(simaTexts)
      })
  }
}
